/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MessageDto } from '../../models/message-dto';

export interface MessageGet$Json$Params {
  InsurerId?: string;
  MessageId?: number;
  MessageName?: string;
}

export function messageGet$Json(http: HttpClient, rootUrl: string, params?: MessageGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MessageDto>>> {
  const rb = new RequestBuilder(rootUrl, messageGet$Json.PATH, 'get');
  if (params) {
    rb.query('InsurerId', params.InsurerId, {});
    rb.query('MessageId', params.MessageId, {});
    rb.query('MessageName', params.MessageName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MessageDto>>;
    })
  );
}

messageGet$Json.PATH = '/v1/Message/Get';
